import { useMemo } from 'react';

import type { ElementProps } from '../@types/forms/types';

/**
 * Parses and memoizes form structure JSON
 * Only re-parses when the structure string actually changes
 * @param structure - JSON string of form structure
 * @returns Parsed array of form elements
 */
export const useParsedFormStructure = (structure: string | undefined): ElementProps[] =>
  useMemo(() => {
    if (!structure) return [];

    try {
      return JSON.parse(structure) as ElementProps[];
    } catch (e) {
      console.error('Failed to parse form structure:', e);
      return [];
    }
  }, [structure]);
